<template>
  <div class="powerBiContainer">
     <div id="reportContainer" />
  </div>
</template>

<script>
import { service, factories, models } from "powerbi-client";

export default {
  data() {
    return {
      props: {
        msg: String
      }
    };
  },
  mounted() {
    this.$auth.getPowerBiToken().then(
      token => {
        this.$powerBiApi.get("/myorg/groups/" + this.$store.state.powerbiConfigurations.cashFlowGroupId + "/reports/" + this.$store.state.powerbiConfigurations.businessStrategyKpuPaginated).then(
          response => {
            const config = {
              type: "report",
              tokenType: models.TokenType.Aad,
              accessToken: token.accessToken,
              embedUrl: response.data.embedUrl  + "&rp:keyProjectId=" + this.$route.query.keyProjectId,
              id: this.$store.state.powerbiConfigurations.businessStrategyKpuPaginated,
              permissions: models.Permissions.All,
              settings: {
                filterPaneEnabled: true,
                navContentPaneEnabled: true
              }
            };

            const powerbi = new service.Service(
              factories.hpmFactory,
              factories.wpmpFactory,
              factories.routerFactory
            );

            const reportContainer = document.getElementById("reportContainer");
            const report = powerbi.embed(reportContainer, config);

            // Report.off removes a given event handler if it exists.
            report.off("loaded");

            // Report.on will add an event handler which prints to Log window.
            report.on("loaded", function () {
              console.log("Loaded");
            });

            // Report.off removes a given event handler if it exists.
            report.off("rendered");

            // Report.on will add an event handler which prints to Log window.
            report.on("rendered", function () {
              console.log("Rendered");
            });

            report.on("error", function (event) {
              console.log(event.detail);
              report.off("error");
            });

            report.off("saved");
            report.on("saved", function (event) {
              if (event.detail.saveAs) {
                console.log(
                  "In order to interact with the new report, create a new token and load the new report"
                );
              }
            });
          }
        );
      }
    );
  }
};
</script>
<style lang="scss">
  #reportContainer {
    width: 100%;
    height: 600px;
  }

</style>
